module.exports = __webpack_public_path__ + "static/img/9.57caf34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/9.png
// module id = S6gw
// module chunks = 0